<div class="popup">
  <div *ngIf="isLoading" class="popup__loader-block">
    <div class="loader-block">
      <div class="loader-block__loader"></div>
      <div class="loader-block__loader-message">{{ loadingMessage }}</div>
    </div>
  </div>
  <div *ngIf="!isLoading" class="popup__message-block">
    <div class="message__text-block">{{ message }}</div>
    <div *ngIf="isDelete" class="message__delete-block">
      <button-cmp (click)="onCancelClick()" isNormal="true"></button-cmp>
      <button-cmp (click)="onDeleteClick()" isDelete="true"></button-cmp>
    </div>
    <div class="message__ok-block" *ngIf="isOk">
      <button-cmp (click)="onOkClick()" isOk="true"></button-cmp>
    </div>
  </div>
</div>
